import { PodType } from '../models/request-and-responses/rest-api/enums/podType.enum';

export interface IPodTypeObject {
    value: PodType;
    label: string;
}

export const PodTypeObjects: IPodTypeObject[] = [
    { value: PodType.BTUsoDomestico, label: 'BT uso domestico' },
    {
        value: PodType.BTIlluminazionePubblica,
        label: 'BT illuminazione pubblica'
    },
    { value: PodType.BTAltriUsi, label: 'BT altri usi' },
    {
        value: PodType.MTIlluminazionePubblica,
        label: 'MT illuminazione pubbblica'
    },
    { value: PodType.MTAltriUsi, label: 'MT altri usi' },
    { value: PodType.ATFinoA150kv, label: 'AT fino a 150 kV' },
    { value: PodType.AATFinoA380kv, label: 'AAT fino a 380 kV' },
    { value: PodType.BTVeicoliElettrici, label: 'BT veicoli elettrici' },
    { value: PodType.ATFinoA220kv, label: 'AT fino a 220 kV' },
    { value: PodType.AATOltre380kv, label: 'AAT oltre 380 kV' },
    {
        value: PodType.BTUsoDomesticoPompeCalore,
        label: 'BT uso domestico con pompe di calore'
    }
];



// WEBPACK FOOTER //
// ./src/app/helpers/podTypeObjects.ts